module.exports = __webpack_public_path__ + "static/img/112_TO8_1816.2ce22fd.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/112_TO8_1816.jpg
// module id = ANY8
// module chunks = 0